<template>
  <div class="loading-container">
    <div class="loader">
      <svg class="loader-svg" viewBox="0 0 80 80">
        <circle class="loader-circle-outer" cx="40" cy="40" r="36" />
        <circle class="loader-circle-middle" cx="40" cy="40" r="28" />
        <circle class="loader-circle-inner" cx="40" cy="40" r="20" />
        <circle class="loader-dot dot1" cx="40" cy="4" r="3" />
        <circle class="loader-dot dot2" cx="40" cy="76" r="3" />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppLoading"
};
</script>

<style>
.loading-container {
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, rgba(151, 152, 153, 0.05) 0%, rgba(151, 152, 153, 0.1) 100%);
}

.loader {
  position: relative;
  width: 120px;
  height: 120px;
}

.loader-svg {
  width: 100%;
  height: 100%;
  animation: rotate 2s linear infinite;
}

.loader-circle-outer,
.loader-circle-middle,
.loader-circle-inner {
  fill: none;
  stroke-width: 2px;
  stroke-linecap: round;
}

.loader-circle-outer {
  stroke: #979899;
  stroke-dasharray: 226;
  stroke-dashoffset: 226;
  transform-origin: center;
  animation: circle-outer 2s ease-in-out infinite;
}

.loader-circle-middle {
  stroke: #70499D;
  stroke-dasharray: 176;
  stroke-dashoffset: 176;
  animation: circle-middle 2s ease-in-out infinite;
}

.loader-circle-inner {
  stroke: #181B1C;
  stroke-dasharray: 126;
  stroke-dashoffset: 126;
  animation: circle-inner 2s ease-in-out infinite;
}

.loader-dot {
  fill: #979899;
  transform-origin: center;
}

.dot1 {
  animation: dot1 2s ease-in-out infinite;
}

.dot2 {
  animation: dot2 2s ease-in-out infinite;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes circle-outer {
  0% {
    stroke-dashoffset: 226;
  }
  50% {
    stroke-dashoffset: 56.5;
  }
  100% {
    stroke-dashoffset: 226;
  }
}

@keyframes circle-middle {
  0% {
    stroke-dashoffset: 176;
  }
  50% {
    stroke-dashoffset: 44;
  }
  100% {
    stroke-dashoffset: 176;
  }
}

@keyframes circle-inner {
  0% {
    stroke-dashoffset: 126;
  }
  50% {
    stroke-dashoffset: 31.5;
  }
  100% {
    stroke-dashoffset: 126;
  }
}

@keyframes dot1 {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
  }
}

@keyframes dot2 {
  0%, 100% {
    transform: scale(1.5);
  }
  50% {
    transform: scale(1);
  }
}

/* Dark theme adjustments */
@media (prefers-color-scheme: dark) {
  .loading-container {
    background: linear-gradient(135deg, rgba(24, 27, 28, 0.05) 0%, rgba(24, 27, 28, 0.1) 100%);
  }
  
  .loader-circle-outer {
    stroke: #979899;
  }
  
  .loader-circle-middle {
    stroke: #8B5FBF;
  }
  
  .loader-circle-inner {
    stroke: #A881E6;
  }
  
  .loader-dot {
    fill: #979899;
  }
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .loader {
    width: 80px;
    height: 80px;
  }
}
</style>